/*
 * This code is protected by intellectual property rights.
 * Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
 * © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
 */

import { Component, Input, ChangeDetectionStrategy } from '@angular/core'

@Component({
  selector: 'pidx-inline-form-messages',
  templateUrl: './pidx-inline-form-messages.component.html',
  standalone: false,
  // Angular 22 changed the implicit default to OnPush (see angular/angular#67687). This component was never migrated
  // to OnPush semantics, so Eager restores the pre-v22 behaviour it relies on.
  // eslint-disable-next-line @angular-eslint/prefer-on-push-component-change-detection
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class PidxInlineFormMessagesComponent {
  @Input() messages: string[] = []
  /**
   * Optional DOM id forwarded to the live region wrapper so the associated form
   * control can reference it via `aria-describedby` (WCAG 3.3.1 / 4.1.2).
   */
  @Input() id?: string
}
